import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=6dba999b&"
import script from "./orderList.vue?vue&type=script&lang=ts&"
export * from "./orderList.vue?vue&type=script&lang=ts&"
import style0 from "./orderList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports